/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ role: NonNullable<unknown> }} Role_Switched_ToInputs */

const en_role_switched_to = /** @type {(inputs: Role_Switched_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Role switched to ${i?.role}`)
};

const es_role_switched_to = /** @type {(inputs: Role_Switched_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rol cambiado a ${i?.role}`)
};

/**
* | output |
* | --- |
* | "Role switched to {role}" |
*
* @param {Role_Switched_ToInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const role_switched_to = /** @type {((inputs: Role_Switched_ToInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Role_Switched_ToInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_role_switched_to(inputs)
	return es_role_switched_to(inputs)
});